import React from 'react';
import {Route, Switch, useRouteMatch, withRouter} from "react-router-dom";

// Other Leagues Pages
import LeagueEditionSelection from "./LeagueEditionSelection";
import LeagueSelection from "./LeagueSelection";
import LeagueDivisionSelection from "./LeagueDivisionSelection";
import Details from "./Details";

const OtherLeagues = (props) => {
   let otherLeagues = useRouteMatch();

   return <Switch>
      <Route exact path={`${otherLeagues.path}/:leagueEditionId/leagues`} component={LeagueSelection}/>
      <Route exact path={`${otherLeagues.path}/:leagueEditionId/leagues/:leagueId/league-divisions`} component={LeagueDivisionSelection}/>
      <Route exact path={`${otherLeagues.path}/:leagueEditionId/leagues/:leagueId/league-divisions/:leagueDivisionId/details`} component={Details}/>
      <Route exact path={`${otherLeagues.path}`} component={LeagueEditionSelection}/>
   </Switch>
}

export default withRouter(OtherLeagues);